import React from "react";

export default function FormModal({ open, title, children, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/35 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-2xl rounded-3xl border border-border bg-card shadow-elevated">
        <div className="px-6 py-4 border-b border-border flex items-center justify-between">
          <h3 className="font-display text-2xl">{title}</h3>
          <button type="button" className="text-sm text-muted-foreground hover:text-foreground" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

